module.exports = __webpack_public_path__ + "html/section-logo-video-sign-up_29f2fcc4dbef7bde60d0e966d243c8da.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-logo-video-sign-up.html
// module id = bxKh
// module chunks = 60